module.exports = __webpack_public_path__ + "img/message_top.ea5b3fdb.png";